import { DisplayMoney } from '@tock/money/src/DisplayMoney';
import { FC } from 'react';
import { Stats } from 'utils/calendar';
import { Theme } from '@emotion/react';
import { Typography } from 'omakase';
import {
  communalCountItem,
  priceItem,
  rightContent,
} from 'components/business/search/booking-card/bookingCardTimeDetailsCssDefs';

// Export for tests
export interface BookingCardTimeDetailsProps {
  communalCountText: string;
  isAvailable: boolean;
  isNotAvailableToCurrentUser: boolean;
  priceInfo: Stats;
  purchaseSize: number;
  renderPrice: boolean;
  reschedulePriceInfo: Stats | undefined;
  useLightTheme?: boolean;
}

export const BookingCardTimeDetails: FC<BookingCardTimeDetailsProps> = ({
  communalCountText,
  isAvailable,
  isNotAvailableToCurrentUser,
  priceInfo,
  purchaseSize,
  renderPrice,
  reschedulePriceInfo,
  useLightTheme = true,
}) => {
  const displayMinRequiredPrice = priceInfo.priceDisplayStyle === 'MIN_REQUIRED_SPEND';
  const displayPurchaseSize =
    !displayMinRequiredPrice ||
    priceInfo.minRequiredSpend?.priceDisplayDistribution !== 'PER_PARTY';

  const minPriceToDisplayCents = displayMinRequiredPrice
    ? priceInfo.minRequiredSpend?.totalCents
    : priceInfo.ticketPriceInformation?.amountCents;

  const displayPrice = minPriceToDisplayCents
    ? minPriceToDisplayCents
    : reschedulePriceInfo
      ? reschedulePriceInfo.priceRange.max
      : renderPrice
        ? priceInfo.priceRange.max
        : null;

  const purchaseSizeDisplay =
    priceInfo.ticketPriceInformation?.priceDistribution === 'PER_PARTY' ? (
      'per party'
    ) : (
      <>&times; {purchaseSize}</>
    );

  const timeDetails = isAvailable && !isNotAvailableToCurrentUser && (
    <span css={rightContent}>
      {!!communalCountText && (
        <span
          data-testid="communal-count-text"
          css={(theme: Theme) =>
            communalCountItem(theme, {
              isLast: !renderPrice,
              isWide: true,
              useLightDivider: useLightTheme,
            })
          }
        >
          {communalCountText}
        </span>
      )}
      {renderPrice && (
        <Typography
          variant="body02"
          color="fgSubtle"
          component="span"
          css={useLightTheme && priceItem}
          data-testid="search-result-price"
        >
          <DisplayMoney amount={displayPrice} roundIfWholeNumber={true} />{' '}
          {displayPurchaseSize && purchaseSizeDisplay}
        </Typography>
      )}
    </span>
  );

  return <>{timeDetails}</>;
};
